<template>
  <div>
    <el-menu class="menu" :router="true" mode="horizontal" background-color="#545c64" text-color="#fff"
      active-text-color="#ffd04b">
      <el-menu-item index="/">VidEvent</el-menu-item>
      <el-menu-item index="/example" style="margin-left: auto;">Examples</el-menu-item>
      <el-menu-item index="/download">Download</el-menu-item>
      <el-menu-item @click="openMessage">Paper</el-menu-item>
      <!-- <el-menu-item @click="openMessage">Code</el-menu-item> -->


    </el-menu>
    <div style="padding:0 40px">

      <h1 class="title">Notice on Video Availability and Access</h1>
      <p class="description">
        This dataset is constructed using publicly accessible videos originally shared on the<strong> Douyin (TikTok
          China)</strong>
        platform.
        While we provide complete annotations for all videos, a portion of the original video links are no longer
        available due to content removal or platform updates.<br>
        To ensure research reproducibility, we have archived the corresponding video files locally.
        Researchers who wish to obtain these unavailable videos may request access by contacting the dataset maintainer
        at
        <a href="mailto:liangbaoyu96@buaa.edu.cn"
          class="text-blue-500 hover:underline">liangbaoyu96@buaa.edu.cn</a>.<br>
      </p>
      <h2>Access Requirements:</h2>
      <p class="description">
        The video files are <strong>strictly for academic research use only</strong>.<br>
        Applicants must submit a signed <strong>Video Data Usage Agreement</strong>.<br>
        The dataset authors reserve the right to review and approve requests on a case-by-case basis.<br>
        Please include your full name, institutional affiliation, and a brief description of your intended use when
        making the request.<br>
      </p>
      <div>
        <el-button type="primary" icon="el-icon-download" @click="downloadJson" :loading="isLoading"
          size="medium">Download JSON Data
        </el-button>
        <el-button type="primary" icon="el-icon-download" @click="downloadAgreement" :loading="isLoading"
          size="medium">Download Usage Agreement
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  methods: {
    openMessage() {
      window.open('http://arxiv.org/abs/2506.02448', '_blank');
    },
    downloadAgreement() {
      this.isLoading = true;

      try {
        const link = document.createElement('a');
        link.href = `${process.env.BASE_URL}Video_Data_Usage_Agreement.pdf`;
        link.download = 'VidEvent_Data_Usage_Agreement.pdf';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('Download begins!');
      } catch (error) {
        console.error('download failed', error);
        this.$message.error('download failed, please try again later');
      } finally {
        this.isLoading = false;
      }

    },
    downloadJson() {
      this.isLoading = true;

      try {
        const link = document.createElement('a');
        link.href = `${process.env.BASE_URL}VidEventv250610.zip`;
        link.download = 'VidEvent_v250610.zip';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('Download begins!');
      } catch (error) {
        console.error('download failed', error);
        this.$message.error('download failed, please try again later');
      } finally {
        this.isLoading = false;
      }

    }
  }

}
</script>

<style scoped>
.menu {
  padding: 0 25px;
  display: flex;
  justify-content: space-between;
  font-size: large;
}

.el-menu-item {
  font-size: 22px;
  font-family: Arial, sans-serif;
}

.title {
  margin: 10px 50px 50px 50px;
  font-size: 40px;
}

.description {
  margin: 50px 10%;
  font-size: 20px;
}

.statistics {
  /* height: 300px; */
  padding: 10px 50px 0 50px;
  /* margin: 50px 0 0 0; */
  /* background-color: #bcd4ef; */
}

.content {
  padding-top: 25px;
}

.el-row-number {
  /* margin: 0px 50px; */
}

.grid-content {
  display: flex;
  flex-direction: column;
  justify-content: start;
  /* border-radius: 4px; */
  min-height: 350px;
  margin: 20px 20px;
}

.content_img {
  object-fit: scale-down;
  height: 150px;
  margin: 30px 0;
}

.grid-number {
  height: 130px;
  margin: 50px 30px;
  padding: 30px;
  border-radius: 8px;
  background-color: #bcd4ef;

}

.grid-number-desc {
  margin-top: 20px;
}

.text-center {
  padding: 30px 0;
  background-color: #f8f9fa;
}
</style>